import ApiAccess from "@/services/ApiAccess.js";

export const state = {
  user: Object,
  role: Object,
  permsAdventures: Object,
  token: null,
  isAdmin: false
};

export const getters = {
  userAuthenticated: state => state.user != null && state.token != null,
  canCreateAdventures: state =>
    state.isAdmin == true ||
    (state.permsAdventures != null && state.permsAdventures.create == "full")
};

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_ROLE(state, role) {
    state.role = role;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permsAdventures = permissions;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_IS_ADMIN(state, isAdmin) {
    state.isAdmin = isAdmin;
  }
};

export const actions = {
  fetchUser({ dispatch, state }, [email, password]) {
    dispatch("fetchUserToken", [email, password])
      .then(() => {
        dispatch("fetchUserObject", state.token)
          .then(() => {
            dispatch("fetchUserRole", [state.token, state.user.roles[0].role]);
          })
          .then(() => {
            dispatch("fetchUserPermissions", state.token);
          });
      })
      .catch(() => {
        dispatch("clearUser");
      });
  },
  fetchUserToken({ commit, dispatch }, [email, password]) {
    return ApiAccess.getAccessToken(email, password)
      .then(response => {
        commit("SET_TOKEN", response.data.data.token);
      })
      .catch(error => {
        dispatch("setNotification", error, {
          root: true
        });
        throw error;
      });
  },
  fetchUserObject({ commit, dispatch }, token) {
    return ApiAccess.getUser(token)
      .then(response => {
        commit("SET_USER", response.data.data);
      })
      .catch(error => {
        dispatch("setNotification", [error, "fetchUserObject"], {
          root: true
        });
        throw error;
      });
  },
  fetchUserRole({ commit, dispatch }, [token, roleId]) {
    return ApiAccess.getUserRole(token, roleId)
      .then(response => {
        commit("SET_ROLE", response.data.data);
        commit("SET_IS_ADMIN", response.data.data.name == "Administrator");
      })
      .catch(error => {
        dispatch("setNotification", [error, "fetchUserPermissions"], {
          root: true
        });
        throw error;
      });
  },
  fetchUserPermissions({ commit, dispatch }, token) {
    return ApiAccess.getUserPermissionsForCollection(token, "adventures")
      .then(response => {
        commit("SET_PERMISSIONS", response.data.data);
      })
      .catch(error => {
        dispatch("setNotification", [error, "fetchUserPermissions"], {
          root: true
        });
        throw error;
      });
  },
  clearUser({ commit }) {
    commit("SET_USER", null);
    commit("SET_ROLE", null);
    commit("SET_PERMISSIONS", null);
    commit("SET_TOKEN", null);
    commit("SET_IS_ADMIN", false);
  },
  testStuff({ state }) {
    ApiAccess.testTokenStuff(state.userToken);
  }
};
